import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../hooks/useLanguage';
import { fetchProducts } from '../../services/productApi';
import { getTranslatedProduct } from '../../utils/translationUtils';
import { useCurrency } from '../../context/CurrencyContext';

const SubcategoryGrid = ({ subcategory }) => {
  const { i18n } = useTranslation();
  const { getLocalizedPath } = useLanguage();
  const { formatPrice } = useCurrency();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!subcategory) return;
    (async () => {
      setLoading(true);
      setError('');
      try {
        const params = new URLSearchParams({
          page: '1',
          limit: '24',
          category: 'Paints',
          subcategory,
        });
        const res = await fetchProducts(params);
        setItems(res.data || []);
      } catch (e) {
        setError(e.message || 'Failed to load products');
      } finally {
        setLoading(false);
      }
    })();
  }, [subcategory]);

  if (loading) return <div className="py-20 text-center">Loading...</div>;
  if (error)
    return <div className="py-20 text-center text-red-600">{error}</div>;

  return (
    <div className="justify-items-center grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-8 lg:gap-x-[50px] lg:gap-y-10">
      {items.map((p) => (
        <div
          key={p.id}
          className="bg-white rounded-[15px] mx-auto max-w-[287px] w-full hover:shadow-md transition-all duration-300"
        >
          <Link
            to={getLocalizedPath(`/product/${encodeURIComponent(p.id)}`)}
            className="block"
          >
            <div className="rounded-[15px] bg-[#EDEDED] overflow-hidden h-[360px] flex items-center justify-center">
              <img
                src={
                  (p.images && p.images[0]) || '/assets/paint-product-1.webp'
                }
                alt={p.name}
                className="w-full h-full object-contain"
              />
            </div>
          </Link>
          <div className="pt-6 text-center pb-4">
            <p className="text-[#A0A0A0] text-[12px] leading-[24px] font-medium">
              Limited Edition
            </p>
            <h3 className="text-[#1D1D1F] text-[16px] leading-[24px] font-medium mt-[9px]">
              {getTranslatedProduct(p, 'name', i18n.language)}
            </h3>
            <p className="text-[#1D1D1F] text-[16px] leading-[22px] font-medium">
              {formatPrice(p.price ?? 0)}
            </p>
          </div>
        </div>
      ))}
      {items.length === 0 && (
        <div className="col-span-full text-center text-[#6b7280]">
          No products found in this subcategory yet.
        </div>
      )}
    </div>
  );
};

export default SubcategoryGrid;
